/*
 * Delivery estimate ("Get it by <date range>") for in-stock products.
 *
 * 1. window.wsgDeliveryEstimate.label(minDays, maxDays) — the date range shown on the PDP
 *    inventory line (snippets/inventory-line-script.liquid) and written to the cart as the
 *    "Estimated delivery" line item property so it follows the item into the basket and checkout.
 * 2. Cart sync: the estimate is calculated when the item is added, so a line that sits in the
 *    basket for a few days (or was added from a quick-add form without the property) is brought
 *    up to date here, together with the "Availability" property (In stock / Pre-order) that
 *    checkout prints under the line. snippets/cart-item.liquid renders [data-line-sync] with the
 *    wanted values; when they differ from the stored properties the line is updated via
 *    /cart/change.js and the visible date is patched in place (no drawer re-render, so no update loops).
 */
(function () {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var PROPERTY = 'Estimated delivery';

  function addWorkingDays(date, days) {
    var d = new Date(date);
    var count = 0;
    while (count < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) count++;
    }
    return d;
  }

  function ordinal(n) {
    if (n > 3 && n < 21) return 'th';
    return ['th', 'st', 'nd', 'rd'][n % 10] || 'th';
  }

  function formatDate(d) {
    return d.getDate() + ordinal(d.getDate()) + ' ' + MONTHS[d.getMonth()];
  }

  function label(minDays, maxDays) {
    var now = new Date();
    var from = addWorkingDays(now, minDays);
    var to = addWorkingDays(now, maxDays);

    if (minDays === maxDays) return formatDate(from);

    var sameMonth = from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear();
    if (sameMonth) return from.getDate() + ordinal(from.getDate()) + '–' + formatDate(to);

    return formatDate(from) + '–' + formatDate(to);
  }

  window.wsgDeliveryEstimate = { label: label, property: PROPERTY };

  /* ---------- Cart sync ---------- */

  var AVAILABILITY = 'Availability';
  var attempted = {};
  var queue = Promise.resolve();
  var timer;

  function patchLine(el, text) {
    var item = el.closest('.cart-item');
    if (!item) return;
    el.dataset.current = text;
    var value = item.querySelector('.product-option--delivery-estimate .value');
    if (value) {
      value.textContent = text;
      return;
    }
    var options = item.querySelector('.options');
    if (!options) return;
    var row = document.createElement('div');
    row.className = 'product-option product-option--delivery product-option--delivery-estimate';
    var labelEl = document.createElement('span');
    labelEl.className = 'label';
    labelEl.textContent = (el.dataset.label || PROPERTY) + ': ';
    var valueEl = document.createElement('span');
    valueEl.className = 'value';
    valueEl.textContent = text;
    row.appendChild(labelEl);
    row.appendChild(valueEl);
    options.appendChild(row);
  }

  // Availability goes first so checkout lists it above the delivery date; every other property
  // (the pre-order app's "Expected Delivery" and its hidden _essential_* keys included) is kept as is.
  function mergeProperties(current, availability, delivery) {
    var properties = {};
    if (availability) properties[AVAILABILITY] = availability;
    Object.keys(current || {}).forEach(function (key) {
      if (key === AVAILABILITY && availability) return;
      properties[key] = current[key];
    });
    if (delivery) properties[PROPERTY] = delivery;
    return properties;
  }

  function syncLine(el) {
    var key = el.dataset.lineKey;
    if (!key || attempted[key]) return;

    var availability = el.dataset.availability || null;
    if (availability === el.dataset.availabilityCurrent) availability = null;

    var delivery = null;
    var min = parseInt(el.dataset.deliveryMin, 10);
    var max = parseInt(el.dataset.deliveryMax, 10);
    if (!isNaN(min)) {
      delivery = label(min, isNaN(max) ? min : max);
      if (delivery === el.dataset.current) delivery = null;
    }

    if (!availability && !delivery) return;
    attempted[key] = true;

    // One line at a time, each against the cart as it is now: the pre-order app writes its own
    // properties on the same lines after page load, and a stale copy would wipe them.
    queue = queue
      .then(function () {
        return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        var line = (cart.items || []).filter(function (item) { return item.key === key; })[0];
        // The line changed since it was rendered; the next render carries the new key and retries.
        if (!line) return;
        return fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: line.quantity, properties: mergeProperties(line.properties, availability, delivery) })
        }).then(function (response) {
          if (!response.ok) throw new Error('cart/change ' + response.status);
          if (delivery) patchLine(el, delivery);
        });
      })
      .catch(function (e) {
        console.warn('Cart line property sync failed', e);
      });
  }

  function sync() {
    document.querySelectorAll('[data-line-sync]').forEach(syncLine);
  }

  function later() {
    clearTimeout(timer);
    timer = setTimeout(sync, 150);
  }

  function observe() {
    document.querySelectorAll('cart-drawer, cart-items').forEach(function (el) {
      if (el.wsgDeliveryObserved) return;
      el.wsgDeliveryObserved = true;
      new MutationObserver(later).observe(el, { childList: true, subtree: true });
    });
  }

  function init() {
    if (!window.routes || !window.routes.cart_change_url) return;
    observe();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
